import base from './base'
import { styled } from '@egoist/vue-emotion'

export default styled(base)`
  width: ${props => props.theme.selected.button.icon.width}px;
  height: ${props => props.theme.selected.button.icon.height}px;
  padding: 0;
`
